const button = "_button_vczzf_8";
const destructive = "_destructive_vczzf_107";
const styles = {
  button,
  "icon-only": "_icon-only_vczzf_50",
  "has-icon": "_has-icon_vczzf_57",
  destructive
};
export {
  button,
  styles as default,
  destructive
};
//# sourceMappingURL=Button.module.css.js.map
